import router from 'app/router'

export default {

	namespaced: true,

	state: {

		weight: 'polar',
		duration: 'range',
		type: 'category',
		efficiency: 'polar',
		coverage: 'polar',
		share: 'polar'

	},

	getters: {

		active: function(state) {

			return {
				'type': state.type !== 'category',
				'duration': state.type !== 'range',
				'weight': state.weight !== 'polar',
				'efficiency': state.efficiency !== 'polar',
				'coverage': state.coverage !== 'polar',
				'share': state.share !== 'polar'
			}

		},

		values: function(state) {

			return {
				'type': state.type,
				'duration': state.duration,
				'weight': state.weight,
				'efficiency': state.efficiency,
				'coverage': state.coverage,
				'share': state.share
			}

		},

		type: function(state) {

			return state.type

		},

		weight: function(state) {

			return state.weight

		},

		efficiency: function(state) {

			return state.efficiency

		},

		coverage: function(state) {

			return state.coverage

		},

		share: function(state) {

			return state.share

		},

		duration: function(state) {

			return state.duration

		}

	},

	mutations: {

		reset: function(state) {

			state.duration = 'range'
			state.weight = 'polar'
			state.type = 'category'
			state.efficiency = 'polar'
			state.coverage = 'polar'
			state.share = 'polar'

		},

		type: function(state, value) {

			state.type = value

		},

		weight: function(state, value) {

			state.weight = value

		},

		duration: function(state, value) {

			state.duration = value

		},

		efficiency: function(state, value) {

			state.efficiency = value

		},

		coverage: function(state, value) {

			state.coverage = value

		},

		share: function(state, value) {

			state.share = value

		}

	},

	actions: {

		analyse: function(context, params) {

			return new Promise(function(resolve) {

				context.commit('reset')

				if (params !== undefined) {

					if (params['type']) context.state.type = params['type']
					if (params['duration']) context.state.duration = params['duration']
					if (params['weight']) context.state.weight = params['weight']
					if (params['efficiency']) context.state.efficiency = params['efficiency']
					if (params['coverage']) context.state.coverage = params['coverage']
					if (params['share']) context.state.share = params['share']

				}

				resolve()

			})

		},

		route: function(context) {

			var urlParams = {}

			if (context.state.type !== 'category') urlParams['type'] = context.state.type
			if (context.state.duration !== 'range') urlParams['duration'] = context.state.duration
			if (context.state.weight !== 'polar') urlParams['weight'] = context.state.weight
			if (context.state.efficiency !== 'polar') urlParams['efficiency'] = context.state.efficiency
			if (context.state.coverage !== 'polar') urlParams['coverage'] = context.state.coverage
			if (context.state.share !== 'polar') urlParams['share'] = context.state.share

			router.replace({query: urlParams}).catch(function() {})

		}

	}

}